const __filename = "/app/components/client_reviews_carousel/component.js", __dirname = "/app/components/client_reviews_carousel";
import WebComponent from '@rubygems/hue/app/components/web_component'

WebComponent.register(
  class extends WebComponent {
    static componentName = 'components-client-reviews-carousel-component'
    static actions = {
      click: ['onNavLeft', 'onNavRight']
    }
    static observedAttributes = ['data-current-index']

    slideCount = this.$$('[data-slide]').length

    get isNavLeftDisabled() {
      return this.currentIndex == 0
    }

    get isNavRightDisabled() {
      return this.slideCount == this.currentIndex + 1
    }

    onNavLeft() {
      this.currentIndex -= 1
    }

    onNavRight = () => {
      this.currentIndex += 1
    }

    get currentIndex() {
      return Number.parseInt(this.dataset.currentIndex)
    }

    set currentIndex(value) {
      this.dataset.currentIndex = value
    }

    dataCurrentIndexChanged(_oldValue, newValue) {
      this.$navLeftTarget && (this.$navLeftTarget.disabled = this.isNavLeftDisabled)
      this.$navRightTarget && (this.$navRightTarget.disabled = this.isNavRightDisabled)

      this.$$('[data-slide]').forEach(ele => {
        if (ele.dataset.slide === newValue) {
          ele.dataset.current = true
        } else {
          delete ele.dataset.current
        }
      })
    }
  }
)
